import { GroupMembershipCodeValidationResponse } from "@treefort/api-spec"
import strictEncodeUriComponent from "@treefort/lib/strict-encode-uri-component"

import api from "./api"
import authenticator from "./authenticator"

export const checkGroupMembershipCode = async (
  membershipCode: string,
): Promise<GroupMembershipCodeValidationResponse> => {
  const res = await api.get<GroupMembershipCodeValidationResponse>(
    `/group-membership-codes/validation/${strictEncodeUriComponent(
      membershipCode,
    )}`,
  )
  return res.data
}

export async function signUpForGroupMembership({
  subscriptionPlanId,
  membershipCode,
}: {
  subscriptionPlanId: number
  membershipCode: string
}) {
  const user = await authenticator.getUser()
  return api.post(`/users/${user?.id}/subscriptions`, {
    provider: "groupMembership",
    subscriptionPlanId,
    membershipCode,
  })
}
